module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fill_info == '') ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.form.name))]), _vm._v(" "), (_vm.palyazati_adatok.kar != undefined) ? _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kar",
      "label": "A pályázó kar",
      "name": "kar",
      "iconclass": "fa fa-pencil"
    },
    model: {
      value: (_vm.palyazati_adatok.kar),
      callback: function($$v) {
        _vm.palyazati_adatok.kar = $$v
      },
      expression: "palyazati_adatok.kar"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "oktato",
      "label": "A kirándulásért felelős oktató neve",
      "iconclass": "fa fa-pencil",
      "name": "oktato"
    },
    model: {
      value: (_vm.palyazati_adatok.oktato),
      callback: function($$v) {
        _vm.palyazati_adatok.oktato = $$v
      },
      expression: "palyazati_adatok.oktato"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "oktato_email",
      "label": "A felelős oktató e-mail címe",
      "iconclass": "fa fa-pencil",
      "name": "oktato_email"
    },
    model: {
      value: (_vm.palyazati_adatok.oktato_email),
      callback: function($$v) {
        _vm.palyazati_adatok.oktato_email = $$v
      },
      expression: "palyazati_adatok.oktato_email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "tanszek",
      "label": "A pályázó tanszék",
      "iconclass": "fa fa-pencil",
      "name": "tanszek"
    },
    model: {
      value: (_vm.palyazati_adatok.tanszek),
      callback: function($$v) {
        _vm.palyazati_adatok.tanszek = $$v
      },
      expression: "palyazati_adatok.tanszek"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "oktato_tel",
      "label": "A felelős oktató telefonszáma",
      "iconclass": "fa fa-pencil",
      "name": "oktato_tel"
    },
    model: {
      value: (_vm.palyazati_adatok.oktato_tel),
      callback: function($$v) {
        _vm.palyazati_adatok.oktato_tel = $$v
      },
      expression: "palyazati_adatok.oktato_tel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "hallgato",
      "label": "A kirándulásért hallgató oktató neve",
      "iconclass": "fa fa-pencil",
      "name": "hallgato"
    },
    model: {
      value: (_vm.palyazati_adatok.hallgato),
      callback: function($$v) {
        _vm.palyazati_adatok.hallgato = $$v
      },
      expression: "palyazati_adatok.hallgato"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "hallgato_tel",
      "label": "A felelős hallgató telefonszáma",
      "iconclass": "fa fa-pencil",
      "name": "hallgato_tel"
    },
    model: {
      value: (_vm.palyazati_adatok.hallgato_tel),
      callback: function($$v) {
        _vm.palyazati_adatok.hallgato_tel = $$v
      },
      expression: "palyazati_adatok.hallgato_tel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "hallgato_email",
      "label": "A felelős hallgató e-mail címe",
      "iconclass": "fa fa-pencil",
      "name": "hallgato_email"
    },
    model: {
      value: (_vm.palyazati_adatok.hallgato_email),
      callback: function($$v) {
        _vm.palyazati_adatok.hallgato_email = $$v
      },
      expression: "palyazati_adatok.hallgato_email"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "szak",
      "label": "A kiránduláson résztvevő hallgatók szakja",
      "iconclass": "fa fa-pencil",
      "name": "szak"
    },
    model: {
      value: (_vm.palyazati_adatok.szak),
      callback: function($$v) {
        _vm.palyazati_adatok.szak = $$v
      },
      expression: "palyazati_adatok.szak"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "letszam",
      "label": "A kiránduláson résztvevő hallgatók létszáma",
      "iconclass": "fa fa-pencil",
      "name": "hallgato_tel"
    },
    model: {
      value: (_vm.palyazati_adatok.letszam),
      callback: function($$v) {
        _vm.palyazati_adatok.letszam = $$v
      },
      expression: "palyazati_adatok.letszam"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("\n                  Az utazás módja\n                ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.palyazati_adatok.utazas_modja),
      expression: "palyazati_adatok.utazas_modja"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "utazas_modja",
      "id": "utazas_modja"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.palyazati_adatok.utazas_modja = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.utazasi_modok), function(um, i) {
    return _c('option', {
      domProps: {
        "value": um.value
      }
    }, [_vm._v(_vm._s(um.text))])
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "tantargy",
      "label": "A kiránduláshoz kapcsolódó tantárgy neve",
      "iconclass": "fa fa-pencil",
      "name": "hallgato_tel"
    },
    model: {
      value: (_vm.palyazati_adatok.tantargy),
      callback: function($$v) {
        _vm.palyazati_adatok.tantargy = $$v
      },
      expression: "palyazati_adatok.tantargy"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "regexp_filter": "[0-9]+",
      "id": "koltseg",
      "label": "A kirándulás tervezett költsége",
      "iconText": "Ft",
      "name": "koltseg"
    },
    model: {
      value: (_vm.palyazati_adatok.koltseg),
      callback: function($$v) {
        _vm.palyazati_adatok.koltseg = $$v
      },
      expression: "palyazati_adatok.koltseg"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "helyszin",
      "label": "A tanulmányi kirándulás tervezett helyszíne",
      "iconclass": "fa fa-pencil",
      "name": "helyszin"
    },
    model: {
      value: (_vm.palyazati_adatok.helyszin),
      callback: function($$v) {
        _vm.palyazati_adatok.helyszin = $$v
      },
      expression: "palyazati_adatok.helyszin"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "regexp_filter": "[0-9]+",
      "id": "tamogatas_osszege",
      "label": "Az igényelt támogatás összege",
      "iconText": "Ft",
      "name": "tamogatas_osszege"
    },
    model: {
      value: (_vm.palyazati_adatok.tamogatas_osszege),
      callback: function($$v) {
        _vm.palyazati_adatok.tamogatas_osszege = $$v
      },
      expression: "palyazati_adatok.tamogatas_osszege"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "regexp_filter": "[0-9]+",
      "id": "tavolsag",
      "label": "A helyszín távolsága Győrtől",
      "iconText": "km",
      "name": "tavolsag"
    },
    model: {
      value: (_vm.palyazati_adatok.tavolsag),
      callback: function($$v) {
        _vm.palyazati_adatok.tavolsag = $$v
      },
      expression: "palyazati_adatok.tavolsag"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    ref: "kezdet",
    attrs: {
      "errors": _vm.errors,
      "id": "kezdet",
      "datepicker": true,
      "datepickeropts": {
        'maxDate': this.veg
      },
      "label": "A kirándulás tervezett kezdete",
      "iconclass": "fa fa-pencil",
      "name": "kezdet"
    },
    on: {
      "onchange": _vm.kezdDateChange
    },
    model: {
      value: (_vm.palyazati_adatok.kezdet),
      callback: function($$v) {
        _vm.palyazati_adatok.kezdet = $$v
      },
      expression: "palyazati_adatok.kezdet"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    ref: "veg",
    attrs: {
      "errors": _vm.errors,
      "id": "veg",
      "datepicker": true,
      "datepickeropts": {
        'minDate': this.kezdet
      },
      "label": "A kirándulás tervezett vége",
      "iconclass": "fa fa-pencil",
      "name": "veg"
    },
    on: {
      "onchange": _vm.vegDateChange
    },
    model: {
      value: (_vm.palyazati_adatok.veg),
      callback: function($$v) {
        _vm.palyazati_adatok.veg = $$v
      },
      expression: "palyazati_adatok.veg"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('textareabox', {
    attrs: {
      "errors": _vm.errors,
      "cstyle": "min-height: 100px",
      "placeholder": "",
      "autogrow": true,
      "iconclass": "fa fa-pencil",
      "id": "ismerteto",
      "label": "A tanulmányi kirándulás rövid ismertetése, szakmai célja",
      "name": "ismerteto"
    },
    model: {
      value: (_vm.palyazati_adatok.ismerteto),
      callback: function($$v) {
        _vm.palyazati_adatok.ismerteto = $$v
      },
      expression: "palyazati_adatok.ismerteto"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "name": "kuld",
      "disabled": !_vm.save_enabled
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Beküld")])])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fill_info != ''),
      expression: "fill_info != ''"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.form.name))]), _vm._v(" "), _c('div', {
    staticClass: "article-text",
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  }, [_vm._v(_vm._s(_vm.fill_info))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "info-box warning"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "title": "Kitöltési útmutató"
    }
  }, [_vm._v("Kitöltési útmutató letöltése")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('span', [_vm._v("Pályázati adatok")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e8377cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/tanulmanyi_kirandulas_palyazat.vue
// module id = 376
// module chunks = 0